import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface PaginationChange {
  page: number;
  pageSize: number;
}

@Component({
  selector: 'ss-pagination',
  templateUrl: './pagination.component.html',
  standalone: false
})
export class PaginationComponent {
  @Input() total = 0;
  @Input() page = 1;
  @Input() pageSize = 15;
  @Input() pageSizeOptions: number[] = [15, 50, 100];
  @Input() label = 'resultados';
  @Input() compact = false;
  @Input() disabled = false;
  @Output() pageChange = new EventEmitter<PaginationChange>();

  get pageCount(): number { return Math.max(1, Math.ceil(this.total / Math.max(1, this.pageSize))); }
  get currentPage(): number { return Math.min(this.pageCount, Math.max(1, this.page)); }
  get first(): number { return this.total ? (this.currentPage - 1) * this.pageSize + 1 : 0; }
  get last(): number { return Math.min(this.currentPage * this.pageSize, this.total); }

  get pages(): (number | null)[] {
    const count = this.pageCount;
    const current = this.currentPage;
    if (count <= 7) return Array.from({ length: count }, (_, index) => index + 1);
    if (current <= 4) return [1, 2, 3, 4, 5, null, count];
    if (current >= count - 3) return [1, null, count - 4, count - 3, count - 2, count - 1, count];
    return [1, null, current - 1, current, current + 1, null, count];
  }

  goTo(page: number) {
    if (this.disabled || page === this.currentPage || page < 1 || page > this.pageCount) return;
    this.pageChange.emit({ page, pageSize: this.pageSize });
  }

  changeSize(event: Event) {
    const pageSize = Number((event.target as HTMLSelectElement).value);
    if (this.disabled || !this.pageSizeOptions.includes(pageSize)) return;
    this.pageChange.emit({ page: 1, pageSize });
  }
}
